import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderGodAllComfort from "../../../../src/content/god-of-all-comfort/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderGodAllComfort,
  React
};